import UbiNoInsuranceBottomSheet from '@di-shared/features/ubi/UbiNoInsuranceBottomSheet';
import React from 'react';
import BottomSheetWebViewWrapper from '@di-shared/features/common/BottomSheetWebViewWrapper';

const BOTTOM_SHEET_FALLBACK_HEIGHT = 500;

function UbiNoInsurancePage() {
  return (
    <BottomSheetWebViewWrapper bottomSheetFallbackHeight={BOTTOM_SHEET_FALLBACK_HEIGHT}>
      <UbiNoInsuranceBottomSheet />
    </BottomSheetWebViewWrapper>
  );
}

export default UbiNoInsurancePage;
